<template>
<div class="page_content" :aria-label="pageTitle + ' Page Content'">
  <div>
    <div class="hidden-container">
      <form method="POST" id="subOrgCsvUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
        <input type="file" id="subOrgCsvFileList" ref="fileInput" name="fileList" rel="subOrgCsvFile" accept=".csv" @change="fileToBeUploaded" aria-label="select file" />
      </form>
    </div>
    <div class="row page-heading">
    <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ico-employer"></span>
        <span class="module_type_name">{{ pageTitle }}</span>
     </div>

     <div class="col-5 btn_container">
     	<b-btn @click="uploadSchoolClicked" aria-label="upload">upload</b-btn>
      <b-btn @click="goToSchools" aria-label="cancel">cancel</b-btn>
     </div>

  </div>

  	<div class="create-section">
  		<div class="content-section">
			<div class="row content-row">
				<div class="col-4 form-label">
					<label for="chooseSchoolFileButton">Select CSV file</label>
				</div>
				<div class="col-8">
					<b-btn id="chooseSchoolFileButton" @click="chooseFileClicked">Choose File</b-btn>
					<span class="selected-file-name" v-if="fileUploadArray.length > 0">{{fileUploadArray[0].fileName}}</span>
			     	<span class="selected-file-name" v-else>No file chosen</span>
				</div>
			</div>
			<div class="row note-section">
				<div class="col-4 form-label"></div>
				<div class="col-8">
          <span><strong>Note:</strong> Uploaded {{ getSubOrgLabel }} will appear under this employer's {{ getSubOrgTabLabel }} tab.</span>
        </div>
			</div>
			<div class="sample-csv-link">
		     	<a href="#" @click.prevent="downloadSampleCsv" aria-label="click here to get a copy of the sample csv file">Click here</a> <span class="link-text">to get a copy of the sample csv file.</span>
		     </div>
		</div>
  </div>
  </div>

  <div class="modal_container modal_alart">
    <b-modal class="" ref="uploadErrorModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
            <span v-html="errorMessage"></span>
        </div>
      <div slot="modal-header" class="header-section">
        <div class="ic ic-hd"></div>
        <div class="head_txt">Error Message!</div>
        <button type="button" class="btn_close" @click="hideUploadErrorModal" :aria-label="$t('closeAria')">
          <span class="ic-close"></span>
        </button>
      </div>
      <div slot="modal-footer" class="w-100">
          <b-button @click="hideUploadErrorModal" class="btn button-primary float-right mr-2" aria-label="ok"> ok </b-button>
      </div>
    </b-modal>
  </div>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import Papa from 'papaparse'
import employerSettingsFlags from '../employerSettingsFlags'

var CSV_COLUMNS = ['externalId', 'title', 'description', 'mission', 'logo', 'website', 'city', 'state', 'country', 'address', 'contanctTitle', 'contanctName', 'phone', 'fax', 'email', 'youtubeUri', 'facebookUri', 'linkedinUri']

var isCsvFile = function (file) {
  var fileName = file.name
  var regEx = /(.csv)$/i
  return regEx.test(fileName)
}

var getFileName = function (fileName) {
  if (!fileName && fileName !== null) {
    return null
  }
  return fileName.replace(/\.\w+$/g, '')
}

var getUpdatedFileName = function (title, fileName) {
  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
  if (ext !== '' || ext !== null) {
    return (title + '.' + ext)
  } else {
    return fileName
  }
}

var FileObject = function (title, file, size, timestamp, type) {
  this.title = getFileName(title)
  this.file = file
  this.fileName = getUpdatedFileName(this.title, title)
  this.size = size
  this.contentFileType = type
  this.timestamp = timestamp
  this.id = timestamp
}

export default {
  name: 'sub-org-upload',
  mixins: [employerSettingsFlags],
  props: ['uuid'],
  data: () => {
    return {
      fileUploadArray: [],
      userId: '',
      errorMessage: '',
      csvColumns: CSV_COLUMNS
    }
  },
  mounted () {
    this.loadDataForSchoolUpload()
  },
  methods: {
    ...mapActions([
      'uploadSubOrganizationCsvFile',
      'loadPermission'
    ]),
    loadDataForSchoolUpload () {
      let userObj = JSON.parse(localStorage.getItem('userobj') || '{}')
      this.userId = userObj.uuid || localStorage.getItem('userid') || ''
      this.loadPermission()
    },
    employerUuid () {
      return this.uuid || (this.$route && this.$route.params && this.$route.params.uuid) || ''
    },
    goToSchools () {
      let employerId = this.employerUuid()
      if (!employerId) {
        this.$router.push({ name: 'employerAdmin' })
        return
      }
      this.$router.push({
        name: 'employerDetails',
        params: { uuid: employerId },
        query: { tab: 'schools' }
      })
    },
    uploadSchoolClicked () {
      if (this.fileUploadArray.length <= 0) {
        this.$notify({
          group: 'notify',
          type: 'warn',
          title: '',
          text: 'Please upload a valid CSV file to upload ' + this.getSubOrgLabel + '.'
        })
        return
      }
      this.uploadFiles()
    },
    chooseFileClicked () {
      this.clearFilePath()
      $('input[type=file][rel=subOrgCsvFile]').click()
    },
    fileToBeUploaded (ev) {
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length) {
        return
      }
      if (!isCsvFile(files[0])) {
        this.clearFilePath()
        this.errorMessage = 'Please Select CSV file'
        this.$refs.uploadErrorModal.show()
        return
      }
      this.prepareFileUploadArray(files)
    },
    prepareFileUploadArray (files) {
      if (files) {
        var timestamp = new Date().getTime()
        for (var i = 0; i < files.length; i++) {
          timestamp = timestamp + i
          this.addFileToUploadArray(files[i], timestamp)
        }
      }
    },
    addFileToUploadArray (newFile, timestamp) {
      var isFound = _.find(this.fileUploadArray, function (file) {
        return ((newFile.name === file.title) && (newFile.size === file.size))
      })
      if (!isFound) {
        this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
      }
    },
    uploadFiles () {
      if (this.fileUploadArray.length <= 0) {
        return
      }
      let fileObject = this.fileUploadArray[0]
      this.readCsvFileAndShowWarningIfExists(fileObject)
    },
    normalizeHeader (value) {
      return (value || '').replace(/^\ufeff/, '').trim().toLowerCase()
    },
    readCsvFileAndShowWarningIfExists (fileObject) {
      let self = this
      let requiredHeaders = ['title']
      let reader = new FileReader()
      reader.onload = fileLoadedEvent => {
        Papa.parse(fileLoadedEvent.target.result, {
          header: true,
          skipEmptyLines: true,
          complete (results) {
            self.errorMessage = ''
            let missing = []
            let rawFields = (results.meta && results.meta.fields) ? results.meta.fields : []
            let fields = _.map(rawFields, (v) => { return self.normalizeHeader(v) })
            $.each(requiredHeaders, (i, val) => {
              if (!_.includes(fields, val.toLowerCase())) {
                if (missing.length === 0) {
                  missing.push(val)
                } else {
                  missing.push(' ' + val)
                }
              }
            })
            if (missing.length > 0) {
              self.errorMessage = 'Headers <strong>[' + missing + ']</strong> are missing.<BR><BR>Please fix the error and re-upload.'
            }
            if (self.errorMessage.length > 0) {
              self.$refs.uploadErrorModal.show()
            } else {
              let parentId = self.employerUuid()
              if (!parentId) {
                self.errorMessage = 'Employer is required to upload ' + self.getSubOrgLabel + '.'
                self.$refs.uploadErrorModal.show()
                return
              }
              let data = new FormData()
              data.append('file', fileObject.file, fileObject.title)
              self.uploadSubOrganizationCsvFile({
                parentId: parentId,
                createdByUuid: self.userId,
                fileData: data
              }).then(response => {
                self.fileUploadArray = []
                if (response && response.taskId) {
                  return self.$router.push({ name: 'taskMonitor', params: { taskId: response.taskId } })
                }
                if (!response) {
                  self.errorMessage = 'Unable to upload ' + self.getSubOrgLabel + '.'
                  self.$refs.uploadErrorModal.show()
                  return
                }
                self.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: self.getSubOrgLabel + ' uploaded successfully.'
                })
                self.goToSchools()
              })
            }
          },
          error (errors) {
            console.log('error: ', errors)
            self.errorMessage = 'Unable to read the CSV file.'
            self.$refs.uploadErrorModal.show()
          }
        })
      }
      reader.readAsText(fileObject.file)
    },
    downloadSampleCsv () {
      let header = CSV_COLUMNS.join(',')
      let blob = new Blob([header + '\n'], { type: 'text/csv;charset=utf-8;' })
      let url = window.URL.createObjectURL(blob)
      let link = document.createElement('a')
      link.href = url
      link.download = 'school.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    hideUploadErrorModal () {
      this.$refs.uploadErrorModal.hide()
      this.errorMessage = ''
      this.clearFilePath()
    },
    clearFilePath () {
      this.fileUploadArray = []
      const input = this.$refs.fileInput
      if (!input) {
        return
      }
      input.type = 'text'
      input.type = 'file'
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),
    pageTitle () {
      return this.$t('schoolUpload', { label: this.getSubOrgLabel })
    }
  }
}
</script>

<style scoped>
.hidden-container {
  visibility: hidden;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/app/job/components/SubOrgUpload.vue